import { registerUser  as registerUserService} from "../api/authApi";
import { loginUser as loginUserService } from "../api/authApi";
import { savedevices as savedevicesService } from "../api/dbApi";
import { getDeviceByUser as getDeviceByUserService } from "../api/dbApi";
import { getMessageBydevice as getMessageBydeviceService } from "../api/dbApi";
import { editdevice as editdeviceService } from "../api/dbApi";
import { savecontact as savecontactService } from "../api/dbApi";
import { editcontact as editcontactService } from "../api/dbApi";
import { getContactsByUser  as getContactsByUserService} from "../api/dbApi";


import { savecontactgroup as savecontactgroupService } from "../api/dbApi";
import { editcontactgroup as editcontactgroupService } from "../api/dbApi";
import { getContactGroupByUser  as getContactGroupByUserService} from "../api/dbApi";

import { saveapps as saveappsService } from "../api/dbApi";
import { editapps as editappsService } from "../api/dbApi";
import { getappsByUser  as getappsByUserService} from "../api/dbApi";
import { getSubscriptionPlans as getSubscriptionPlansService } from "../api/dbApi";
import { subscribeToPlan as subscribeToPlanService } from "../api/dbApi";
import { saveSubscriptionPlan as saveSubscriptionPlanService } from "../api/dbApi";
import { getUserStats as getUserStatsService } from "../api/dbApi";
import { getMessageLogs as getMessageLogsService } from "../api/dbApi";
import { editUser as editUserService } from "../api/dbApi";
import { getUsers as getUsersService } from "../api/dbApi";
import { getSubscriptionAnalytics as getSubscriptionAnalyticsService } from "../api/dbApi";
import { getAdminDashboard as getAdminDashboardService } from "../api/dbApi";
import { checkUserLimits as checkUserLimitsService } from "../api/dbApi";
import { savechatbot as savechatbotService } from "../api/dbApi";
import { editchatbot as editchatbotService } from "../api/dbApi";
import { get_rules as get_rulesService } from "../api/dbApi";
import { deletechatbot as deletechatbotService } from "../api/dbApi";
import { saveschedule as savescheduleService } from "../api/dbApi";
import { deleteschedule as deletescheduleService } from "../api/dbApi";
import { getScheduleByDevice as getScheduleByDeviceService } from "../api/dbApi";
import { verifyEmail as verifyEmailService } from "../api/dbApi";
import { sendresetpasswordlink as sendresetpasswordlinkService } from "../api/dbApi";
import { resetpassword as resetpasswordService } from "../api/dbApi";

import { editwebhook as editwebhookService } from "../api/dbApi";
import { savewebhook as savewebhookService } from "../api/dbApi";
import { deletewebhook as deletewebhookService } from "../api/dbApi";
import { getWebhookByUser as getWebhookByUserService } from "../api/dbApi";


import { savesupport as savesupportService } from "../api/dbApi";
import { getsupport as getsupportService } from "../api/dbApi";
import {getSubscriptionRequests as getSubscriptionRequestsService} from "../api/dbApi";
import { approveRequest as approveRequestService } from "../api/dbApi";
import { rejectRequest as rejectRequestService } from "../api/dbApi";


export const approveRequest = async (data) => {
  try {
    let payload = new FormData();
    payload.append('request_id',data)
    
    const response = await approveRequestService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const rejectRequest = async (data) => {
  try {
    let payload = new FormData();
    payload.append('request_id',data)
    
    const response = await rejectRequestService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}


export const getSubscriptionRequests = async () => {
  try {
    
    const response = await getSubscriptionRequestsService();

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}


export const registerUser = async (data) => {
    try {
      let payload = new FormData();
      for (var key in data) {
        payload.append(key, data[key]);
      }
      const response = await registerUserService(payload);
  
      return response;
    } catch (error) {
     return(error.response?.data || "Something Went wrong")
    }
}

export const loginUser = async (data) => {
    try {
      let payload = new FormData();
      for (var key in data) {
        payload.append(key, data[key]);
      }
      const response = await loginUserService(payload);
  
      return response;
    } catch (error) {
     return(error.response?.data || "Something Went wrong")
    }
}

export const savedevices = async (data) => {
    try {
      let payload = new FormData();
      for (var key in data) {
        payload.append(key, data[key]);
      }
      const response = await savedevicesService(payload);
  
      return response;
    } catch (error) {
     return(error.response?.data || "Something Went wrong")
    }
}

export const getDeviceByUser = async (data) => {
  try {
    let payload = new FormData();
    payload.append('user', data);
   
    const response = await getDeviceByUserService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const getMessageBydevice = async (data) => {
  try {
    let payload = new FormData();
    payload.append('device_id', data);
   
    const response = await getMessageBydeviceService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const savecontact = async (data) => {
  try {
    let payload = new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await savecontactService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const editcontact = async (data) => {
  try {
    let payload = new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await editcontactService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const deletecontact = async (data) => {
  try {
    let payload = new FormData();
   

    payload.append('id', data.id);
    payload.append('status','0');
    const response = await editcontactService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const getContactsByUser = async (data) => {
  try {
    let payload = new FormData();
   

    payload.append('user', data.id);
    const response = await getContactsByUserService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}




export const savecontactgroup = async (data) => {
  try {
    let payload = new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await savecontactgroupService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const editcontactgroup = async (data) => {
  try {
    let payload = new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await editcontactgroupService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const deletecontactgroup = async (data) => {
  try {
    let payload = new FormData();
   

    payload.append('id', data.id);
    payload.append('status','0');
    const response = await editcontactgroupService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const getContactGroupByUser = async (data) => {
  try {
    let payload = new FormData();
   

    payload.append('user', data);
    const response = await getContactGroupByUserService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const saveapps = async (data) => {
  try {
    let payload = new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await saveappsService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const editapps = async (data) => {
  try {
    let payload = new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await editappsService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const deleteapps = async (data) => {
  try {
    let payload = new FormData();
   

    payload.append('id', data);
    payload.append('status','0');
    const response = await editappsService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const getappsByUser = async (data) => {
  try {
    let payload = new FormData();
   

    payload.append('user', data);
    const response = await getappsByUserService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}


// 1. Get all plans and user's current status
export const getSubscriptionPlans = async (userId) => {
  try {
    let payload = new FormData();
    payload.append('user_id', userId);
    
    const response = await getSubscriptionPlansService(payload);
    return response;
  } catch (error) {
    return error.response?.data || "Something went wrong fetching plans";
  }
};

// 2. Subscribe a user to a specific plan
export const subscribeToPlan = async (userId, planId) => {
  try {
    let payload = new FormData();
    payload.append('user_id', userId);
    payload.append('plan_id', planId);

    const response = await subscribeToPlanService(payload);
    return response;
  } catch (error) {
    return error.response?.data || "Subscription failed";
  }
};

// 3. Admin: Save or Update a Plan
export const saveSubscriptionPlan = async (planData) => {
  try {
    let payload = new FormData();
    // Dynamically append all plan fields (name, price, limits, etc.)
    Object.keys(planData).forEach(key => {
        payload.append(key, planData[key]);
    });

    const response = await saveSubscriptionPlanService(payload);
    return response;
  } catch (error) {
    return error.response?.data || "Failed to save plan";
  }
};


// Simulate a successful payment gateway response
export const processDemoPayment = async (userId, planId) => {
  try {
    let payload = new FormData();
    payload.append('user_id', userId);
    payload.append('plan_id', planId);
    payload.append('transaction_id', 'DEMO_' + Date.now());

    // We reuse the subscribe logic but call it after payment success
    const response = await subscribeToPlanService(payload);
    return response;
  } catch (error) {
    return error.response?.data || "Payment failed";
  }
};


export const getUserStats = async (userId) => {
  try {
    let payload = new FormData();
    payload.append('user_id', userId);

    // We reuse the subscribe logic but call it after payment success
    const response = await getUserStatsService(payload);
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

export const getMessageLogs = async (userId) => {
  try {
    let payload = new FormData();
    payload.append('user_id', userId);

    // We reuse the subscribe logic but call it after payment success
    const response = await getMessageLogsService(payload);
    return response;
  } catch (error) {
    return error.response?.data;
  }
};



export const editUser = async (data) => {
  try {
    let payload = new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await editUserService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}



export const updatePassword = async (userId, passwords) => {
  let payload = new FormData();
  payload.append('id', userId);
  payload.append('password', passwords.newPassword);
  debugger
  const response = await editUserService(payload);
  return response;
};

export const updateProfileImage = async (userId, base64Image) => {
  let payload = new FormData();
  payload.append('id', userId);
  payload.append('image', base64Image); // Base64 string
  const response = await editUserService(payload);
  return response;
};

export const updateNotificationSetting = async (userId, notificationsetting) => {
  let payload = new FormData();
  payload.append('id', userId);
  payload.append('notificationsetting', notificationsetting); // Base64 string
  const response = await editUserService(payload);
  return response;
};



export const getusers = async () => {
  const response = await getUsersService();
  return response;
};


export const getSubscriptionAnalytics = async () => {
  const response = await getSubscriptionAnalyticsService();
  return response;
};

export const getAdminDashboard = async () => {
  const response = await getAdminDashboardService();
  return response;
};


export const checkUserLimits = async (userId, type) => {
  let payload = new FormData();
  payload.append('id', userId);
  payload.append('type', type); // Base64 string
  const response = await checkUserLimitsService(payload);
  return response;
};



// 3. Admin: Save or Update a Plan
export const savechatbot = async (data) => {
  try {
    let payload = new FormData();
    // Dynamically append all plan fields (name, price, limits, etc.)
    Object.keys(data).forEach(key => {
        payload.append(key, data[key]);
    });

    const response = await savechatbotService(payload);
    return response;
  } catch (error) {
    return error.response?.data || "Failed to save ";
  }
};

export const get_rules = async (device_id) => {
  let payload = new FormData();
  payload.append('device_id', device_id);
  const response = await get_rulesService(payload);
  return response;
};

export const deletechatbot = async (data) => {
  try {
    let payload = new FormData();
   

    payload.append('id', data);
    const response = await deletechatbotService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}


export const saveschedule = async (data) => {
  try {
    let payload = new FormData();
    Object.keys(data).forEach(key => {
        payload.append(key, data[key]);
    });

    const response = await savescheduleService(payload);
    return response;
  } catch (error) {
    return error.response?.data || "Failed to save ";
  }
};


export const deleteschedule = async (data) => {
  try {
    let payload = new FormData();
    payload.append('id', data);
    const response = await deletescheduleService(payload);
    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}



export const getScheduleByDevice = async (data) => {
  try {
    let payload = new FormData();
    payload.append('device', data);
    const response = await getScheduleByDeviceService(payload);
    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}


export const verifymail = async (data) => {
  try {
    const formData = new FormData()
    formData.append('token', data)
    const response = await verifyEmailService(formData)
    return response
  }
  catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


export const sendresetpasswordlink = async (data) => {
  try {
    
    const formData = new FormData()
    formData.append('email', data)
    const response = await sendresetpasswordlinkService(formData) 
    return response
    
  }
  catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}


export const resetpassword = async (data) => {
  try {
    
    const formData = new FormData()
    formData.append('token', data.token)
    formData.append('password', data.password)
    const response = await resetpasswordService(formData) 
    return response
    
  }
  catch (error) {
    throw new Error(error.response?.data || "Something Went wrong")
  }
}



export const savewebhook = async (data) => {
  try {
    let payload = new FormData();
    Object.keys(data).forEach(key => {
        payload.append(key, data[key]);
    });
    const response = await savewebhookService(payload);
    return response;
  } catch (error) {
    return error.response?.data || "Failed to save ";
  }
};

export const editwebhook = async (data) => {
  try {
    let payload = new FormData();
    Object.keys(data).forEach(key => {
        payload.append(key, data[key]);
    });
    const response = await editwebhookService(payload);
    return response;
  } catch (error) {
    return error.response?.data || "Failed to edit ";
  }
};

export const deletewebhook = async (data) => {
  try {
    let payload = new FormData();
    payload.append('id', data);
    const response = await deletewebhookService(payload);
    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const getWebhookByUser = async (data) => {
  try {
    let payload = new FormData();
    payload.append('id', data);
    const response = await getWebhookByUserService(payload);
    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}


export const editdevice = async (data) => {
  try {
    let payload = new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await editdeviceService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}

export const savesupport = async (data) => {
  try {
    let payload = new FormData();
    for (var key in data) {
      payload.append(key, data[key]);
    }
    const response = await savesupportService(payload);

    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}


export const getsupport = async () => {
  try {
    
    const response = await getsupportService();
    return response;
  } catch (error) {
   return(error.response?.data || "Something Went wrong")
  }
}